import {  OfferUpdateImageAndTiner } from "../Model/Offer";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";


export interface GetOfferImagesByIdUseCase {
  invoke: (id: number) => Promise<OfferUpdateImageAndTiner | null>;
}

export class GetOfferImagesById implements GetOfferImagesByIdUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(id: number){
    if(!id){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.Repo.getOfferImagesById(id);
    return getData;
  }
}